import React from "react";

const destinations = [
  {
    name: "Bali, Indonesia",
    image: "https://images.unsplash.com/photo-1537996194471-e657df975ab4?auto=format&fit=crop&w=400&q=80",
  },
  {
    name: "Paris, France",
    image: "https://images.unsplash.com/photo-1502602898657-3e91760cbb34?auto=format&fit=crop&w=400&q=80",
  },
  {
    name: "Rome, Italy",
    image: "https://images.unsplash.com/photo-1552832230-c0197dd311b5?auto=format&fit=crop&w=400&q=80",
  },
  {
    name: "Tokyo, Japan",
    image: "https://images.unsplash.com/photo-1493976040374-85c8e12f0c0e?auto=format&fit=crop&w=400&q=80",
  },
  {
    name: "Switzerland",
    image: "https://images.unsplash.com/photo-1464822759023-fed622ff2c3b?auto=format&fit=crop&w=400&q=80",
  },
  {
    name: "Dubai, UAE",
    image: "https://images.unsplash.com/photo-1512453979798-5ea266f8880c?auto=format&fit=crop&w=400&q=80",
  },
];

export default function PopularDestinations() {
  return (
    <section className="pt-4 pb-8 md:pt-6 md:pb-10 bg-[#f4f2fb]">
      <div className="max-w-7xl mx-auto px-6">
        <div className="flex justify-between items-end mb-8" data-aos="fade-right" data-aos-duration="800">
          <div>
            <span className="text-[11px] font-extrabold text-[#8B2FC9] uppercase tracking-widest">
              EXPLORE TOP DESTINATIONS
            </span>
            <h2 className="text-3xl font-extrabold text-slate-900 mt-1">
              Popular <span className="text-[#8B2FC9]">Destinations</span>
            </h2>
          </div>
         
        </div>

        <style>{`
          @keyframes scrollMarquee {
            0% { transform: translateX(0); }
            100% { transform: translateX(-50%); }
          }
          .animate-marquee {
            animation: scrollMarquee 35s linear infinite;
            display: flex;
            width: max-content;
          }
          .animate-marquee:hover {
            animation-play-state: paused;
          }
        `}</style>

        <div className="overflow-hidden w-full relative pt-6 pb-6 -mt-6">
          <div className="animate-marquee gap-4 items-center">
            {[...destinations, ...destinations, ...destinations, ...destinations].map((dest, i) => (
              <div 
                key={i} 
                className="cursor-pointer w-[160px] sm:w-[190px] md:w-[220px] flex-shrink-0 transition-transform duration-300 hover:scale-105"
              >
                <div className="relative h-44 rounded-xl overflow-hidden shadow-md">
                  <img 
                    src={dest.image} 
                    alt={dest.name} 
                    className="w-full h-full object-cover"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/20 to-transparent" />
                  <div className="absolute bottom-3 left-3 right-3 text-white">
                    <h4 className="font-bold text-xs sm:text-sm leading-tight truncate">{dest.name}</h4>
                    <p className="text-[10px] sm:text-xs text-white/75 mt-0.5">{dest.travelers}</p>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
